import { render } from "./BtnUploadSendReport.vue?vue&type=template&id=79f67545"
import script from "./BtnUploadSendReport.vue?vue&type=script&lang=js"
export * from "./BtnUploadSendReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__